import {baseStyles} from "../styles";
import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";
import {parsedAddressObjectToString} from "../../../../utils/utils";
import {PDFContext} from "../BasePDF";

export const HeaderPDF = ({ pdfName, companyName, customerAddress, customerName }) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{
            ...baseStyles.flexBetween,
            alignItems: 'center',
            alignContent: 'center',
            flexWrap: 'wrap',
            padding: '5px 0px'
        }}>
            <View
                style={{
                    fontSize: '30px',
                    fontWeight: '400',
                    textAlign: 'left',
                    // color: pdfData.pageColor,
                    textTransform: 'uppercase',
                }}
            >
                <Text>{companyName}</Text>
            </View>
            <View>
                <Text
                    style={{
                        fontSize: '10px',
                        color: '#666666',
                        textDecoration: 'underline',
                    }}
                >
                    {pdfName} - {new Date().toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'})}
                </Text>
                <Text
                    style={{
                        fontSize: '10px',
                        color: '#666666',
                    }}
                >
                    {customerName}
                </Text>
                <Text
                    style={{
                        fontSize: '10px',
                        color: '#666666',
                    }}
                >
                    {customerAddress ? parsedAddressObjectToString(customerAddress) : ''}
                </Text>
            </View>
        </View>
    )
}